(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PRO-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.PROTestiEditor) return;
    window.PROTestiEditor = true;
    document.addEventListener('shopify:block:select', function (event) {
      var id = event.detail && event.detail.blockId;
      if (!id) return;
      document.querySelectorAll('.PRO-testimonials [data-pro-block]').forEach(function (slide) {
        if (slide.dataset.proBlock !== id) return;
        var track = slide.closest('[data-pro-track]');
        if (track) track.scrollTo({left: slide.offsetLeft, behavior: 'instant'});
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supz-bild-slider-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('supz-picture-slider')) {
  customElements.define('supz-picture-slider', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.measureFrame);
      clearTimeout(this.timer);
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.removeAttribute('data-ready');
      this.initialized = false;
    }
    init() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.abort.signal });
      this.track = this.querySelector('.sp-track');
      this.slides = Array.from(this.querySelectorAll('.sp-slide'));
      if (!this.slides.length) return;
      this.dots = Array.from(this.querySelectorAll('.sp-dot'));
      this.current = 0;
      this.loop = this.dataset.loop === 'true';
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.editor = Boolean(window.Shopify?.designMode);
      this.userPaused = this.motion.matches || this.editor;
      this.focusPaused = false;
      this.hoverPaused = false;
      this.inView = true;
      this.blockSelected = false;
      this.playButton = this.querySelector('[data-action="play"]');
      this.status = this.querySelector('[data-status]');
      this.show(0, false);
      this.setAttribute('data-ready', '');
      on(this, 'click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.action === 'prev') this.show(this.current - 1, true);
        if (button.dataset.action === 'next') this.show(this.current + 1, true);
        if (button.dataset.index !== undefined) this.show(Number(button.dataset.index), true);
        if (button.dataset.action === 'play') {
          this.userPaused = !this.userPaused;
          // Explicit play can restart rotation even while this button has focus.
          if (!this.userPaused) {
            this.focusPaused = false;
            this.hoverPaused = false;
            if (!this.loop && this.current === this.slides.length - 1) this.show(0, false);
          }
          this.updatePlay();
          this.schedule();
        }
      });
      on(this, 'keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        let target;
        if (event.key === 'ArrowLeft') target = this.current - 1;
        if (event.key === 'ArrowRight') target = this.current + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.slides.length - 1;
        if (target !== undefined) {
          event.preventDefault();
          this.show(target, true);
        }
      });
      on(this, 'pointerenter', (event) => {
        if (event.pointerType === 'mouse') { this.hoverPaused = true; this.schedule(); }
      });
      on(this, 'pointerleave', (event) => {
        if (event.pointerType === 'mouse') { this.hoverPaused = false; this.schedule(); }
      });
      on(this, 'focusin', () => { this.focusPaused = true; this.schedule(); });
      on(this, 'focusout', () => queueMicrotask(() => {
        if (!this.isConnected) return;
        if (!this.contains(document.activeElement)) { this.focusPaused = false; this.schedule(); }
      }));
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => {
        if (this.motion.matches) this.userPaused = true;
        this.updatePlay(); this.schedule();
      });
      if (this.dataset.swipe === 'true') this.bindSwipe(on);
      on(document, 'shopify:block:select', (event) => {
        if (!event.detail?.blockId) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.blockSelected = true;
        this.show(index, false);
      });
      on(document, 'shopify:block:deselect', (event) => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
        this.blockSelected = false;
        this.schedule();
      });
      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => this.measure());
      });
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.schedule();
      }, { threshold: 0 });
      this.intersectionObserver.observe(this);
      this.updatePlay();
      this.schedule();
    }
    show(index, manual) {
      const count = this.slides.length;
      const next = this.loop ? ((index % count) + count) % count : Math.max(0, Math.min(index, count - 1));
      const previous = this.slides[this.current];
      if (next !== this.current && previous?.contains(document.activeElement)) this.focus({ preventScroll: true });
      this.current = next;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
      });
      this.track.style.transform = `translateX(-${next * 100}%)`;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === next);
        if (i === next) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      const prev = this.querySelector('[data-action="prev"]');
      const forward = this.querySelector('[data-action="next"]');
      if (prev) prev.disabled = !this.loop && next === 0;
      if (forward) forward.disabled = !this.loop && next === count - 1;
      const image = this.slides[next].querySelector('img');
      if (image) image.loading = 'eager';
      this.measure();
      if (manual && this.status) this.status.textContent = `${this.dataset.slideLabel} ${next + 1} / ${count}`;
      this.schedule();
    }
    measure() {
      const media = this.slides[this.current]?.querySelector('.sp-media');
      if (media) this.style.setProperty('--sp-active-height', `${media.getBoundingClientRect().height}px`);
    }
    updatePlay() {
      if (!this.playButton) return;
      const label = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.playButton.textContent = label;
      this.playButton.setAttribute('aria-label', label);
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.autoplay || this.userPaused || this.hoverPaused || this.focusPaused || this.blockSelected || document.hidden || !this.inView) return;
      if (!this.loop && this.current === this.slides.length - 1) {
        this.userPaused = true;
        this.updatePlay();
        return;
      }
      this.timer = setTimeout(() => this.show(this.current + 1, false), this.interval);
    }
    bindSwipe(on) {
      const viewport = this.querySelector('.sp-window');
      let gesture = null;
      let suppressUntil = 0;
      on(viewport, 'touchstart', (event) => {
        if (event.touches.length !== 1 || event.target.closest('button')) { gesture = null; return; }
        const touch = event.touches[0];
        gesture = { x: touch.clientX, y: touch.clientY, at: Date.now() };
        clearTimeout(this.timer);
      }, { passive: true });
      on(viewport, 'touchmove', (event) => {
        if (event.touches.length !== 1) gesture = null;
      }, { passive: true });
      on(viewport, 'touchend', (event) => {
        if (gesture && event.changedTouches.length) {
          const touch = event.changedTouches[0];
          const dx = gesture.x - touch.clientX;
          const dy = gesture.y - touch.clientY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - gesture.at < 1200) {
            suppressUntil = Date.now() + 500;
            this.show(this.current + (dx > 0 ? 1 : -1), true);
          }
        }
        gesture = null;
        this.schedule();
      }, { passive: true });
      on(viewport, 'touchcancel', () => { gesture = null; this.schedule(); }, { passive: true });
      on(viewport, 'click', (event) => {
        if (Date.now() < suppressUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { capture: true });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
